import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import LeagueSeasonCreateEditForm from './Components/LeagueSeasonCreateEditForm';
import LeagueSeasonApi from './LeagueSeasonApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: LeagueSeasonCreateEditForm,
                getCreate: LeagueSeasonApi.create,
                defaults: { statsAverages: [], statsTotals: [], standingsTables: [], boxScoreColumns: [], leaderboardTables: [] },
                successMessage: "League Season Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}